<script setup lang="ts">
import { RouterView } from "vue-router";
</script>

<template>
  <div class="min-h-screen bg-base-100 text-neutral">
    <!-- Empty Layout - No header, no navigation, just content -->
    <RouterView />
  </div>
</template>
